import * as yup from 'yup';
import { CreateStudentDebtFormValidation } from './CreateStudentDebtFormValidation';

export const PayStudentDebtTypeFormValidation = yup.object().shape({
    studentDebt:CreateStudentDebtFormValidation, 
    paymentTransation: yup.array().of(
        yup.object().shape({
            amountPaid: yup.number().typeError("Deve ser numero").required('Valor é obrigatória').moreThan(0, 'O valor deve ser maior que zero (0)'),
            date: yup.string().required('Data é obrigatória'),
         //   paymentProof: yup.string().required('Ficheiro é obrigatória'),
            idPaymentType: yup.string().required('Tipo de pagamento é obrigatório'),
            idStudent: yup.string().required('Estudante é obrigatório'),
          })
    ).required('Deve haver pelo menos uma transação').min(1,'Coloque pelo menos uma transação parte')
   });
   /*.test('total-amount', 'A soma dos pagamentos não pode ser maior que o valor actual', function (value) {
        const { studentDebt, paymentTransation } = value;
        const currentAmount = studentDebt?.currentAmount || 0; 
        const totalPaid = paymentTransation?.reduce((sum, transaction) => sum + (transaction.amountPaid || 0), 0) || 0; 
        return totalPaid <= currentAmount;
    });
    */